import { Maybe } from '@crocodille/common';
import cn from 'classnames';
import React from 'react';

import styles from './check.module.scss';

export interface CheckProps {
  readonly className?: Maybe<string>;
  readonly value: boolean;
  onChange?(value: boolean): void;
}

const Check: React.FC<React.PropsWithChildren<CheckProps>> = ({
  value,
  onChange,
  className = null,
}) => {
  return (
    <label
      className={cn(styles.container, { [styles.isChecked]: value }, className)}
      onClick={() => onChange?.(!value)}
    ></label>
  );
};

export default Check;
